module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Partners"},"fr":{"title":"Partenaires"}}')
  delete Component.options._Ctor
}
